// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9cbb32e5","455":"083c15b5","977":"187f9202"}[chunkId] + ".chunk.js";
};